import { render, staticRenderFns } from "./MenuPrestamos.vue?vue&type=template&id=0adf413d&"
import script from "./MenuPrestamos.vue?vue&type=script&lang=js&"
export * from "./MenuPrestamos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports